import { useApolloClient } from "@apollo/client";
import { getDataOrNull } from "@msys/common";
import { useTranslate } from "@tolgee/react";
import { FilterChip } from "../../commons/filters/FilterChip.js";
import { useCrmCompanySelectQuery } from "./CrmCompanySelect.generated.js";

interface Props extends Omit<React.ComponentProps<typeof FilterChip>, "value"> {
  value: string | null | undefined;
}

export function CrmCompanyFilterChip({
  label,
  value,
  onDelete,
  ...props
}: Props) {
  const { t } = useTranslate(["Projects"]);

  const client = useApolloClient();
  const query = useCrmCompanySelectQuery({
    client,
    variables: { limit: 1, filterIds: value ? [value] : [] },
    skip: !value,
  });

  const crmCompany = getDataOrNull(query.data?.crmCompanies)?.edges[0]?.node;
  if (!crmCompany) return null;

  return (
    <FilterChip
      label={label ?? t("CRM contact", { ns: "Projects" })}
      onDelete={onDelete}
      value={crmCompany.title}
      {...props}
    />
  );
}
